import styled from 'styled-components';
import { colors, toRgba, breakPoints } from '@/styles';

export const ControlHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0px;
  border-top: 1px solid ${colors.secondary.lightGray3};
  border-left: 1px solid ${colors.secondary.lightGray3};
  border-right: 1px solid ${colors.secondary.lightGray3};
`;

export const LeftPane = styled.div`
  padding: 10px;
  text-align: right;
  /* border-right: 1px solid ${colors.secondary.lightGray3}; */
  /* margin-right: -1px; */
  min-width: 40px;
  @media (max-width: ${breakPoints.mobile}) {
    display: none;
  }
`;

export const RightPane = styled.div<{ $expanded: boolean }>`
  padding: 10px;
  /* padding-right: 30px; */
  min-width: 40px;
  text-align: right;
  border-left: 1px solid ${colors.secondary.lightGray3};
  border-left-width: ${({ $expanded }) => ($expanded ? '1px' : '0px')};
  background: ${({ $expanded }) => ($expanded ? colors.secondary.lightGray1 : 'transparent')};
  height: 100%;
  @media (max-width: ${breakPoints.mobile}) {
    display: none;
  }
`;

export const ContentPane = styled.div<{ $leftPaneExpanded: boolean }>`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-left: 1px solid ${colors.secondary.lightGray3};
  border-left-width: ${({ $leftPaneExpanded }) => ($leftPaneExpanded ? '1px' : '0px')};
  padding: 0 10px;
  height: 100%;
`;

export const RowCountIndicator = styled.div<{ $selected?: boolean }>`
  padding: 1px 5px;
  border-radius: 5px;

  a {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  border: 1px solid transparent;
  border-width: ${({ $selected }) => ($selected ? '1px' : '0')};
  font-weight: ${({ $selected }) => ($selected ? '500' : 'normal')};

  &.rows-added {
    background: ${toRgba(colors.semantic.diff.added.indicator, 0.15)};
    color: ${colors.semantic.diff.added.indicator};
    border-color: ${colors.semantic.diff.added.indicator};
  }
  &.rows-removed {
    background: ${toRgba(colors.semantic.diff.removed.indicator, 0.1)};
    color: ${colors.semantic.diff.removed.indicator};
    border-color: ${colors.semantic.diff.removed.indicator};
  }
  &.rows-modified {
    background: ${toRgba(colors.semantic.diff.modified.indicator, 0.15)};
    /* color: ${colors.semantic.diff.modified.indicator}; */
    border-color: ${colors.semantic.diff.modified.indicator};
  }
`;
